import React, {Component} from 'react';
import PropTypes from 'prop-types';
import map from 'lodash/map';
import GalleryThumbnail from './GalleryThumbnail';
import {Helmet} from 'react-helmet';
import size from 'lodash/size'
import {withRouter} from 'react-router-dom';
import {imageGrid} from '../imageGrid';
import includes from 'lodash/includes';
import '../css/gallery.scss';
import Mousetrap from 'mousetrap';
import Infinite from 'react-infinite';
import ScrollPosition from './ScrollPosition';

@withRouter
export default class Gallery extends Component {
    static propTypes = {
        srcPrefix: PropTypes.string,
        urlPrefix: PropTypes.string,
        images: PropTypes.array,
        lastVisitedId: PropTypes.number,
        history: PropTypes.object,
        selectedImages: PropTypes.array,
        onToggleSelectImage: PropTypes.func,
        onResetSelection: PropTypes.func,
        width: PropTypes.number,
        thumbnailDefaultHeight: PropTypes.number,
        margin: PropTypes.number,
        hideEditButtons: PropTypes.bool,
        hasOpenModal: PropTypes.func,
    };

    static defaultProps = {
        images: {},
        selectedImages: {},
        urlPrefix: '',
        width: 1000,
        thumbnailDefaultHeight: 180,
        margin: 4,
    };

    componentDidMount() {
        Mousetrap.bind('esc', (e) => {
            // todo: find a better way of binding the esc so that it doesn't trigger this binding when a modal is open
            if (this.isSelectionMode() && !this.props.hasOpenModal()) {
                e.preventDefault();
                this.props.onResetSelection();
            }
        });
    }

    componentWillUnmount() {
        // noinspection JSUnresolvedFunction
        Mousetrap.unbind('esc');
    }

    handleOpenImage = (image) => {
        this.props.history.push(`${this.props.urlPrefix}/image/${image.id}`);
    };

    handleEditImage = (image) => {
        this.props.history.push(`${this.props.urlPrefix}/image/${image.id}`);
    };

    isSelectionMode = () => {
        return size(this.props.selectedImages) > 0;
    };

    render() {
        const {images, srcPrefix, selectedImages, onToggleSelectImage, width, thumbnailDefaultHeight, margin, hideEditButtons} = this.props;
        const count = size(images);
        if (count === 0) {
            return false;
        }
        const lastVisitedId = this.props.lastVisitedId || images[0].id;

        const rows = imageGrid(images, width, thumbnailDefaultHeight, margin);

        const selectionMode = this.isSelectionMode();

        const heights = [];
        let foundLastVisited = false;
        let offsetToVisited = 0;

        const previews = map(rows, (row, r) => {
            let height = 0;
            let rowHasLastVisited;
            const cells = map(row, (cell, k) => {
                height = cell.height;
                const image = images[cell.idx];
                const isLastVisited = image.id === lastVisitedId;
                rowHasLastVisited = rowHasLastVisited || isLastVisited;
                return (
                    <GalleryThumbnail
                        key={k}
                        idx={k}
                        lastVisited={isLastVisited}
                        cell={cell}
                        image={image}
                        onOpen={this.handleOpenImage}
                        onEdit={this.handleEditImage}
                        srcPrefix={srcPrefix}
                        selected={includes(selectedImages, image.id)}
                        onToggleSelectImage={onToggleSelectImage}
                        selectionMode={selectionMode}
                        hideEditButtons={hideEditButtons}
                    />
                );
            });
            if (!rowHasLastVisited && !foundLastVisited) {
                offsetToVisited += height + margin;
            } else {
                foundLastVisited = true;
            }
            heights.push(height + margin);
            return (<div key={r} style={{marginBottom: margin, width: width + margin, height}}>{cells}</div>);
        });
        if (!foundLastVisited) {
            offsetToVisited = 0;
        }

        return (
            <div>
                <Helmet>
                    <link rel="prefetch" href={images[0].origSrc} />
                    <link rel="prefetch" href={images[0].poppedSrc} />
                </Helmet>
                <ScrollPosition position={offsetToVisited}/>
                <Infinite useWindowAsScrollContainer containerHeight={2000} elementHeight={heights}>
                    {previews}
                </Infinite>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/components/Gallery.js